export const styles = theme => ({
    link: {
        textDecoration: "none",
        fontSize: "1rem",
        color: "white",
        "&:hover": {
            textDecoration: "underline solid white 2px"
        },
        display: "flex",
        alignItems: "center",
        padding: "6px 0px 5px 0px",
        "& svg": {
            marginRight: 5
        },
        whiteSpace: "nowrap" as const
    },
    table: {
        width: 450
    },
    tableCell: {
        paddingLeft: "4px",
        paddingRight: "8px",
        borderBottom: "none",
        "&:last-child": {
            paddingRight: "4px"
        }
    },
    tableCellTotal: {
        paddingLeft: "4px",
        paddingRight: "4px",
        borderBottom: "none",
        "&:last-child": {
            paddingRight: "4px"
        }
    },
    root: {
        padding: "16px",
        display: "flex",
        flexDirection: "column" as const
    },
    container: {
        maxHeight: 200
    },
    productCategory: {
        textTransform: "uppercase" as const,
        color: "#9c9c9c",
        fontSize: "0.7rem",
        fontWeight: "bold" as const
    },
    button: {
        alignSelf: "flex-end" as const
    }
});
